// extracted by mini-css-extract-plugin
module.exports = {"iFrame":"Contact_iFrame__1tyVX","contact2":"Contact_contact2__1uCRY","mailContact":"Contact_mailContact__TSyiV","headerKontakt":"Contact_headerKontakt__yuz0g"};